const initialState = {
  activitiesBean: {},
  activitiesBeans: [],
  activitiesDate: null,
  userId: null,
  checkin: 0,
  allCheckin: 0,
  courseName: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHECKIN_GET_CHECKIN":
      return {
        ...state,
        userId: action.userId,
        activitiesDate: action.activitiesDate,
        checkin: action.data.checkin,
        allCheckin: action.data.allCheckin,
        courseName: action.data.courseName,
        activitiesBeans: action.data.activitiesBeans,
      };
    default:
      return state;
  }
};

export default reducer;
